'use client';

import { useEffect } from 'react';

/**
 * Opens a closed FAQ accordion panel when the URL hash names its title button,
 * so `/#pricing` lands on the price answer expanded rather than on a closed
 * question. The Accordion keeps open state by index and ignores `isOpen` on
 * its panels, so clicking the title is the only hook it offers.
 */
export function OpenFaqOnHash({ id }: { id: string }) {
  useEffect(() => {
    const openIfTargeted = () => {
      if (window.location.hash !== `#${id}`) return;
      const title = document.getElementById(id);
      if (!(title instanceof HTMLButtonElement)) return;
      const content = title.nextElementSibling;
      if (content?.hasAttribute('hidden')) title.click();
      title.scrollIntoView({ block: 'start' });
    };
    openIfTargeted();
    window.addEventListener('hashchange', openIfTargeted);
    return () => window.removeEventListener('hashchange', openIfTargeted);
  }, [id]);

  return null;
}
